import type { Bounds } from 'pixi.js';
import { Container } from 'pixi.js';
import type { CollectionEventConfig } from '../types';
import { CollectionEventNodeView } from './CollectionEventNodeView';
import { getCollectionEventRewardProgress, getRewardConfig } from '../model/collectionEventUtils';
import { RecyclableCullingView } from '../../winStreak/views/RecyclableCullingView';

export class CollectionEventRewardTrackView extends Container {
  private readonly recyclableView = new RecyclableCullingView(this);

  public readonly totalHeight: number;

  private readonly nodePositions: number[] = [];

  constructor(eventInstance: CollectionEventConfig) {
    super();

    this.interactiveChildren = false;

    const progress = getCollectionEventRewardProgress(eventInstance, eventInstance.tokensCollected);

    const infiniteReward = getRewardConfig(eventInstance, Math.max(eventInstance.rewards.length, progress.rewardIndex));

    this.recyclableView.addOneWayPiece({
      initializer: () =>
        new CollectionEventNodeView(Infinity, infiniteReward.rewards, false).props({
          parent: this,
          y: 150,
        }),
      y: 150,
    });

    eventInstance.rewards
      .slice()
      .reverse()
      .forEach((rewardConfig, index, array) => {
        const unlocked = array.length - 1 - index < progress.rewardIndex;
        const y = 150 + (index + 1) * 180;

        this.nodePositions.unshift(y);
        this.recyclableView.addOneWayPiece({
          initializer: () =>
            new CollectionEventNodeView(array.length - index, rewardConfig.rewards, unlocked).props({
              parent: this,
              y,
            }),
          y,
        });
      });

    this.totalHeight = (eventInstance.rewards.length + 1.5) * 180;
  }

  public updateRecyclableViews(visibleBounds: Bounds): void {
    this.recyclableView.update(visibleBounds);
  }

  public getNodeY(index: number): number {
    return this.nodePositions[index] ?? 0;
  }
}
